import { Col, Container, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'


const Contacto = () => {
    return(
        <>
            <Navbar />
            <main className='contacto'>
                <Container>
                    <Row>
                        <h1>Contacto</h1>
                    </Row>
                    <Row className='my-5'>
                        <Col md={6}>
                            <a href='tel:91 881 26 25' >
                                <FontAwesomeIcon icon={faPhone} />
                                <p>91 881 26 25</p>
                            </a>
                        </Col>
                        <Col md={6}>
                            <a href='mailto:info@tefric.com'>
                                <FontAwesomeIcon icon={faEnvelope} />
                                <p>info@tefric.com</p>
                            </a>
                        </Col>
                    </Row>
                </Container>
            </main>
            <Footer />
        </>
    )
}

export default Contacto